module.exports = __webpack_public_path__ + "static/media/construction.7fbd48f9.png";